import { createGetExperiment } from 'features/page-model';
import { createFeatureSelector } from 'features/create-feature-selector';
import { createSelector } from 'reselect';
import { getArticle } from 'common/selectors';
import i18next from 'i18next';
import { COMPLEMENTS_PLACEMENT_ID, SUBSTITUTES_PLACEMENT_ID, SUGGESTIONS_PLACEMENT_ID } from './constants';

const getRecoBlockPlacementId = (placementName: string) => {
  return createSelector(createGetExperiment(placementName), (experiment) => experiment?.externalId);
};

export const featureSelector = createFeatureSelector('relatedProducts');

export const getSubstitutes = createSelector(featureSelector, (f) => f?.substitutes ?? []);
export const getComplements = createSelector(featureSelector, (f) => f?.complements ?? []);

export const getCollectionTitle = createSelector(featureSelector, (f) => {
  return f?.collection ? `${i18next.t('carousel-titles.other-collection')} ${f.collection.name}` : '';
});
export const getCollectionMainPhoto = createSelector(featureSelector, (f) => f?.collection?.mainPhoto);
export const getCollectionProducts = createSelector(
  featureSelector,
  getArticle,
  (f, id) => f?.collectionProducts?.filter((productId) => productId !== id) ?? [],
);

export const getComplementsPlacementId = getRecoBlockPlacementId(COMPLEMENTS_PLACEMENT_ID);
export const getSuggestionsPlacementId = getRecoBlockPlacementId(SUGGESTIONS_PLACEMENT_ID);
export const getSubstitutesPlacementId = getRecoBlockPlacementId(SUBSTITUTES_PLACEMENT_ID);
